<template>
    <div class="story-primary-wrapper storygrid-stretch-small">

        <div class="primary-article">

            <div class="image" v-on:click="didSelectStory(story.slug)">
                <div class="image-inner" v-bind:style="{ backgroundImage: 'url(' + story.image + ')' }"></div>
            </div>

            <div class="intro">
                <div class="primary-content">
                    <primary-article :slug="fetchPrimary" :story="story" :hideUpdated="hideUpdated" headingSize="medium" limitSummary="limitSummary"></primary-article>
                </div>
                <div v-if="story && !withinStory" class="intro-footer">
                    <more-sources :slug="fetchPrimary" :story="story"></more-sources>
                    <alternative-articles :alternatives="fetchAlternatives" :story="story" stackRow="true"></alternative-articles>
                </div>
            </div>

        </div>

    </div>
</template>

<script>
    import { Mixins } from '../mixins'
    import PrimaryArticle from '../partials/PrimaryArticle';
    import MoreSources from '../partials/MoreSources';
    import AlternativeArticles from '../partials/AlternativeArticles';

    export default {
        name: 'StoryStretchSmall',
        props: ['story', 'withinStory', 'hideUpdated'],
        mixins: [Mixins],
        components: {
            PrimaryArticle,
            MoreSources,
            AlternativeArticles
        },
        computed: {
            fetchPrimary() {
                if (this.withinStory) {
                    return this.withinStory
                } else if (this.story.primary_article) {
                    return this.story.primary_article.slug
                }
                return '';
            },

            fetchAlternatives() {
                return this.story.alternative_articles;
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '~styles/_variables';
    @import '../grid.scss';

    .primary-article {
        position: relative;
        display: flex;
        flex-direction: row-reverse;
        padding: 1em;
        width: 100%;

        @media (max-width: 450px) {
            padding: 0.5em;
        }

        .intro {
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            width: 100%;
            padding-right: 15px;

            @media (max-width: 475px) {
                padding-right: 0;
            }

            .primary-content {
                display: flex;
                flex-direction: column;
                position: relative;
            }

            .intro-footer {
                margin-top: 30px;
            }

            ::v-deep .intro-heading.medium {
              margin-right: 75px;
            }
        }
    }

    .image {
        width: 65px;
        position: absolute;
        cursor: pointer;
        
        .image-inner {
            width: 100%;
            padding-top: 100%;
            border-radius: $border-radius;
            background-repeat: no-repeat;
            background-size: cover;
            background-position: center;

            img {
                position: absolute;
                top: 0;
                left: 0;
                bottom: 0;
                right: 0;
            }
        }
    }

</style>